import * as React from 'react';

import { ServiceType } from '../../../../../../CardExtra/types';
import { CdnIcon, CdnIconNames } from '@shared/ui/CdnIcon';

interface Props {
	type: ServiceType;
}

const CARD_HEADER_ICONS: Partial<Record<ServiceType, CdnIconNames[]>> = {
	seats: ['Services/Seat Selection', 'Amenity/Seat_Window'],
	baggage: ['Baggage/Musical inst', 'Baggage/Pet in cabin'],
	'baggage-delivery': ['Baggage/Checked-in'],
	meal: ['Services/Meal 2', 'Flight/Direction'],
	insurance: ['Services/Insurance', 'Payment/Cash'],
	transfer: ['Services/Transfer', 'Info/Passengers'],
	loyalty: ['Info/Subscribe', 'Services/Miles'],
	upgrade: ['Arrow/Upward', 'Flight/Direction']
};

const CardExtraAggregatorHeaderIcon: React.FC<Props> = ({ type }) => {
	if (!CARD_HEADER_ICONS[type]) {
		return null;
	}

	return (
		<>
			{CARD_HEADER_ICONS[type].map(icon => (
				<CdnIcon key={icon} icon={icon} />
			))}
		</>
	);
};

export default CardExtraAggregatorHeaderIcon;
